export default "__VITE_PUBLIC_ASSET__4308d1b5__"